export enum GENDER {
  MALE = 'male',
  FEMALE = 'female',
}

export const GenderLabels: Record<GENDER, string> = Object.freeze({
  [GENDER.MALE]: 'Nam',
  [GENDER.FEMALE]: 'Nữ',
});

export const GenderOptions = [
  {
    value: GENDER.MALE,
    label: GenderLabels[GENDER.MALE],
  },
  {
    value: GENDER.FEMALE,
    label: GenderLabels[GENDER.FEMALE],
  },
];

export const CreateNewParamId = 'create';
